// 设置一个元素居中
export const scollToCenter = (el, isFirstLoad = false, scrollElement = null) => {
  if (!el || !scrollElement) {
    return
  }

  const left = el.offsetLeft - scrollElement.offsetWidth / 2 + el.offsetWidth / 2
  if (!isFirstLoad && scrollElement.scroll) {
    scrollElement.scroll({ left, behavior: 'smooth' })
  } else {
    scrollElement.scrollLeft = left
  }
}
